import { render } from "./iconLineasIzquierda.vue?vue&type=template&id=1376dc12&scoped=true"
import script from "./iconLineasIzquierda.vue?vue&type=script&lang=js"
export * from "./iconLineasIzquierda.vue?vue&type=script&lang=js"

import "./iconLineasIzquierda.vue?vue&type=style&index=0&id=1376dc12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1376dc12"

export default script